import MasterActivityFppk from "@/components/fppk/master-activity/MasterActivityFppk.vue";
import MasterActivityFppkAdd from "@/components/fppk/master-activity/MasterActivityFppkAdd.vue";
import MasterActivityFppkDetail from "@/components/fppk/master-activity/MasterActivityFpkkDetail.vue";
import MasterActivityFppkEdit from "@/components/fppk/master-activity/MasterActivityFppkEdit.vue";

let routes= [
    {
      path: '/',
      meta: {
        title: "Chain System",
      },
      name: "MasterActivityFppk",
      component: MasterActivityFppk
    },
    {
      path: 'add',
      meta: {
        title: "Chain System",
      },
      name: "MasterActivityFppkAdd",
      component: MasterActivityFppkAdd
    },
    {
      path: 'detail/:id',
      meta: {
        title: "Chain System",
      },
      name: "MasterActivityFppkDetail",
      component: MasterActivityFppkDetail
    },
    {
      path: 'edit/:id',
      meta: {
        title: "Chain System",
      },
      name: "MasterActivityFppkEdit",
      component: MasterActivityFppkEdit
    },
  ]
  export default routes